import { ViewModel, View, ObservableArray } from "binder"
import { OPCManipulationView } from "./opcManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { OPCEditorViewModel, OPCInserter, OPCUpdater } from "./opcEditor/opcEditor-viewModel";
import { IOPC } from "./IOpc";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { downloadFile } from "src/uicomponents/components/utilities";
import { FileChooser } from "src/common/utilities";

export class OPCManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف OPC';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.opcs = ObservableArray.create<OPC>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

    }
    GetDefaultView(): View<ViewModel> {
        return new OPCManipulationView();
    }
    public getTypeId(): string {
        return "VM-339ADD2D-A1E1-4CD3-B49A-734010704004"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set opcs(v: ObservableArray<OPC>) { this._opcs = v; } public get opcs(): ObservableArray<OPC> { return this._opcs; } private _opcs: ObservableArray<OPC>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/OpcServices/ListAllOpcs', {
                FilteringInformation: filteringInformation
            });
            this.opcs.update(...result.Opcs.map((x, i) => {
                let o = new OPC(this);
                o.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                o.id = x.Id;
                o.name = x.Name;
                o.code = x.Code;
                o.isDisable = x.IsDisabled;
                o.productId = x.ProductId;
                o.productName = x.ProductName;
                o.productCode = x.ProductCode;
                o.canEdit = !x.canEdit;
                return o;
            }));

            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async addNew() {
        let popup = new OPCEditorViewModel(this, new OPCInserter());
        let result = await this.showPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async edit(opc: IOPC) {
        let popup = new OPCEditorViewModel(this, new OPCUpdater());
        await opc.cloneTo(popup);
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async hasEnableOpc(productId: string): Promise<boolean> {
        let result = await ServerConnection.callServer("/Complex/OpcServices/ListEnableOpcs", {
            ProductId: productId
        });
        if (result.IsSuccessful == true) {
            if (result.Opcs.length == 0) {
                return true;
            }
        }
        return false;
    }

    async enableOPC(opc: IOPC) {
        let enable = await ServerConnection.callServer("/Complex/OpcServices/EnableOpc", {
            OpcId: opc.id
        });
        if (enable.IsSuccessful == true) {
            this.dataLoader.refresh();
        }
    }

    async disableOPC(opc: IOPC) {
        let result = await ServerConnection.callServer("/Complex/OpcServices/DisableOpc", {
            OpcId: opc.id
        });
        if (result.IsSuccessful == true) {
            this.dataLoader.refresh();
        }
    }

    async remove(opc: OPC): Promise<void> {
        let isDeleted = await this.messageBoxDangerYesNo('آیا از حذف اطمینان دارید؟', 'حذف');
        if (isDeleted == 'yes') {
            try {
                let result = await ServerConnection.callServer("/Complex/OpcServices/DeleteOpc", {
                    OpcId: opc.id,
                });
                if (result.IsSuccessful == true) {
                    await this.messageBoxConfirmSuccess("حذف با موفقیت انجام شد", "عملیات موفق");
                    this.dataLoader.refresh();
                } else {
                    if (result.Faults[0].Parameters.FaultId == 'D2BF392F-0EC9-4491-9DD3-FF7F3E096630') {
                        await this.messageBoxConfirmWarning("امکان حذف وجود ندارد", "خطا در عملیات");
                    }
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning("خطا در عملیات حذف", "خطا در عملیات");
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
}

export class OPC extends ViewModel implements IOPC {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: OPCManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: OPCManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set productId(v: string) { this._productId = v; } public get productId(): string { return this._productId; } private _productId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set isDisable(v: boolean) { this._isDisable = v; } public get isDisable(): boolean { return this._isDisable; } private _isDisable: boolean;
    public set canEdit(v: boolean) { this._canEdit = v; } public get canEdit(): boolean { return this._canEdit; } private _canEdit: boolean;

    setProductId(id: string) {
        this.productId = id;
    }

    getProductId(): string {
        return this.productId;
    }

    async cloneTo(opc: IOPC) {
        opc.id = this.id;
        opc.name = this.name;
        opc.code = this.code;
        opc.isDisable = this.isDisable;
        opc.canEdit = this.canEdit;
        opc.setProductId(this.productId);
    }

    async edit() {
        this._typedParent.edit(this);
    }

    async enableOPC() {
        let hasEnableOpc = await this._typedParent.hasEnableOpc(this.productId);
        if (hasEnableOpc == false) {
            let isEnabled = await this.messageBoxDangerYesNo("برای این محصول OPC فعال دیگری وجود دارد! درصورت فعالسازی این OPC بقیه OPCهای فعال این محصول غیرفعال می شوند، آیا اطمینان دارید؟", "فعال سازی");
            if (isEnabled == 'yes') {
                this._typedParent.enableOPC(this);
            }
        }
        else {
            let isEnabled = await this.messageBoxWarningYesNo(`آیا ${this.name} فعال سازی شود؟`, `فعال سازی`);
            if (isEnabled == 'yes') {
                this._typedParent.enableOPC(this);
            }
        }
    }

    async disableOPC() {
        let isDisabled = await this.messageBoxWarningYesNo(`آیا ${this.name} غیر فعال سازی شود؟`, `غیر فعال سازی`);
        if (isDisabled == 'yes') {
            this._typedParent.disableOPC(this);
        }
    }

    async remove(): Promise<void> {
        this._typedParent.remove(this);
    }

    async showStructure() {
        let opcStructure = new OPCStructureViewModel(this);
        opcStructure.loadById(this.id);
        this.requestShowingPopup(opcStructure);
    }
}

export class OPCStructureViewModel extends ViewModel implements IPopup {
    public getTypeId(): string { return 'opc-structure'; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this.canSaveTemplate = false;
        this.opList = ObservableArray.create<SingleOP>();
    }

    public set canSaveTemplate(v: boolean) { this._canSaveTemplate = v; } public get canSaveTemplate(): boolean { return this._canSaveTemplate; } private _canSaveTemplate: boolean;
    public set opList(v: ObservableArray<SingleOP>) { this._opList = v; } public get opList(): ObservableArray<SingleOP> { return this._opList; } private _opList: ObservableArray<SingleOP>;
    public set opcId(v: string) { this._opcId = v; } public get opcId(): string { return this._opcId; } private _opcId: string;

    closePopup(result: any) {

    }

    back() {
        this.closePopup(null);
    }

    async loadById(id: string) {
        try {
            this.canSaveTemplate = false;
            this.opcId = id;
            let result = await ServerConnection.callServer('/Complex/OpcServices/GetOpcStructure', {
                OpcId: id
            });
            this.opList.update(...result.Activities.map((x, i) => {
                let s = new SingleOP(this);
                s.index = i + 1;
                s.id = x.Id;
                s.name = x.Name;
                s.code = x.Code;
                s.lineNo = x.LineNo;
                s.typeNo = x.TypeNo;
                s.nextId = x.NextId;
                s.nextCode = x.NextCode;
                s.nextName = x.NextName;
                s.isReportStation = x.IsReportStation;
                s.activityTypes.update(...x.ActivityTypes.map(type => this.convertToActivityType(type)));
                return s;
            }));

        } catch (ex) {
            console.log(ex);
        }
    }

    async downloadTemplate(): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/OpcServices/ExportOpcStructureTemplate', {
        });
        downloadFile(result.ExportData, "ساختار_OPC.xlsx");
        await this.messageBoxConfirmSuccess('دانلود با موفقیت انجام شد.', 'موفق');
    }

    async requestUploadExcel() {
        try {
            let fileChooser = new FileChooser;
            let choosedFile = await fileChooser.chooseFile();
            if (choosedFile.isChoosed == true) {
                let result = await ServerConnection.callServer('/Complex/OpcServices/GetOpcStructureFromExcel', {
                    OpcId: this.opcId,
                    ExcelFile: choosedFile.fileContent
                });
                this.opList.update(...result.Activities.map((x, i) => {
                    let s = new SingleOP(this);
                    s.index = i + 1;
                    s.name = x.ActivityName;
                    s.code = x.ActivityCode;
                    s.lineNo = x.LineNo;
                    s.typeNo = x.TypeNo;
                    s.intId = x.Id;
                    s.nextIntId = x.NextId;
                    s.nextCode = x.NextActivityCode;
                    s.nextName = x.NextActivityName;
                    s.isReportStation = x.IsReportStation;
                    s.activityTypes.update(...x.ActivityTypes.map(item => this.convertToActivityType(item)));
                    return s;
                }));

                this.canSaveTemplate = true;
                await this.messageBoxConfirmSuccess('آپلود با موفقیت انجام شد، نتایج در جدول نمایش داده شد.', 'موفق');
            }
        } catch (ex) {
            await this.messageBoxConfirmWarning("مشکلی در ساختار آپلود شده وجود دارد", "خطا");
            console.log(ex);
        }
    }

    convertToActivityType(dto: any): ActivityType {
        let activityType = new ActivityType(this);
        activityType.id = dto.ActivityTypeId;
        activityType.name = dto.ActivityTypeName;
        activityType.code = dto.ActivityTypeCode;
        return activityType;
    }

    async saveStructure() {
        this.canSaveTemplate = true;
        let isDeleted = await this.messageBoxWarningYesNo('آیا از ذخیره سازی اطمینان دارید؟', 'ذخیره سازی');
        if (isDeleted == 'no') {
            return;
        }
        let result = await ServerConnection.callServer("/Complex/OpcServices/UpdateOpcStructure", {
            OpcId: this.opcId,
            Activities: this.opList.map(q => {
                return {
                    IntId: q.intId,
                    Code: q.code,
                    Name: q.name,
                    LineNo: q.lineNo,
                    NextIntId: q.nextIntId,
                    TypeNo: q.typeNo,
                    IsReportStation : q.isReportStation,
                    ActivityTypeIds: q.activityTypes.map(type => type.id)
                }
            })
        });
        if (result.IsSuccessful == true) {
            await this.messageBoxConfirmSuccess('ذخیره سازی با موفقیت انجام شد.', 'موفق');
            this.closePopup('done');
        }
        else {
            await this.messageBoxConfirmWarning("خطا در عملیات", "خطا در عملیات");
        }
    }
}

export class SingleOP extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this.activityTypes = ObservableArray.create<ActivityType>();
        this._updateRequestTime = 1000;
    }

    private _updateRequestTime: number;
    private _updateRequestTimeout: NodeJS.Timeout;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set intId(v: number) { this._intId = v; } public get intId(): number { return this._intId; } private _intId: number;
    public set nextIntId(v: number) { this._nextIntId = v; } public get nextIntId(): number { return this._nextIntId; } private _nextIntId: number;
    public set nextId(v: string) { this._nextId = v; } public get nextId(): string { return this._nextId; } private _nextId: string;
    public set nextName(v: string) { this._nextName = v; } public get nextName(): string { return this._nextName; } private _nextName: string;
    public set nextCode(v: string) { this._nextCode = v; } public get nextCode(): string { return this._nextCode; } private _nextCode: string;
    public set lineNo(v: string) { this._lineNo = v; } public get lineNo(): string { return this._lineNo; } private _lineNo: string;
    public set typeNo(v: string) { this._typeNo = v; } public get typeNo(): string { return this._typeNo; } private _typeNo: string;
    public set activityTypes(v: ObservableArray<ActivityType>) { this._activityTypes = v; this.updateActivityTypesName(); } public get activityTypes(): ObservableArray<ActivityType> { return this._activityTypes; } private _activityTypes: ObservableArray<ActivityType>;
    public set activityTypesName(v: string) { this._activityTypesName = v; } public get activityTypesName(): string { return this._activityTypesName; } private _activityTypesName: string;
    public set isReportStation(v: boolean) { this._isReportStation = v; } public get isReportStation(): boolean { return this._isReportStation;} private _isReportStation: boolean;
    
    updateActivityTypesName(): void {
        if (this._updateRequestTimeout != null) {
            clearTimeout(this._updateRequestTimeout);
        }

        this._updateRequestTimeout = setTimeout(() => {
            this.activityTypesName = this.activityTypes.map(item => item.name).join(", ");
        }, this._updateRequestTime)
    }
}

export class ActivityType extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
}
